/**
 * Utility for mapping media types to icons
 *
 * These icons are used in dropdown options to visually indicate the media type.
 * They appear in the dropdown menu but not in selected values or titles.
 */

import {type MediaCardType} from '@wandb/weave/common/types/media';

export type MediaIconName =
  | 'photo-picture'
  | 'video-play'
  | 'cube-container'
  | 'music-audio'
  | 'table'
  | 'chart-line'
  | 'code-alt'
  | 'molecule'
  | 'help-alt';

/**
 * Maps media card types to their corresponding icon names.
 *
 * @param mediaType - The media card type
 * @returns The icon name for the media type, or 'help-alt' if unknown
 */
export function getMediaTypeIcon(mediaType: MediaCardType): MediaIconName {
  switch (mediaType) {
    case 'image':
      return 'photo-picture';
    case 'video':
      return 'video-play';
    case 'object3D':
      return 'cube-container';
    case 'audio':
      return 'music-audio';
    case 'table':
      return 'table';
    case 'plotly':
    case 'bokeh':
      return 'chart-line';
    case 'html':
      return 'code-alt';
    case 'molecule':
      return 'molecule';
    default:
      return 'help-alt';
  }
}
